import {match} from 'ts-pattern';

import {always} from 'ramda';

import {getLevelIndicatorFlags, LevelIndicator} from '@dms/shared';

/**
 * @about Narrows an order variant's mandatory-field predicate by what the vehicle actually has.
 *
 * A variant can mark the fuel tank mandatory for every order it covers, but an electric vehicle
 * never renders a fuel gauge — leaving the requirement in place would fail validation on a field
 * the user cannot see or fill, so the order could never be submitted. The battery charge mirrors
 * it for combustion vehicles. Every other field passes straight through.
 */
export const getLevelAwareFieldRequired = (
  isFieldRequired: (name: string) => boolean,
  levelIndicators: LevelIndicator[]
) => {
  const {hasFuel, hasBattery} = getLevelIndicatorFlags(levelIndicators);

  return (name: string) =>
    isFieldRequired(name) &&
    match(name)
      .with('fuelTank', always(hasFuel))
      .with('batteryCharge', always(hasBattery))
      .otherwise(always(true));
};
